import Loading from "components/loading2";
import React from "react";
import styled from "styled-components";

interface IButton {
  name?: string | React.ReactNode;
  icon?: React.ReactNode;
  onClick?: (e?: any) => void;
  background?: string;
  color?: string;
  fontSize?: number;
  fontWeight?: number;
  lineHeight?: string;
  padding?: string;
  width?: string;
  bdr?: string; // border radius
  border?: string;
  margin?: string;
  type?: "button" | "submit" | "reset" | undefined;
  disabled?: boolean;
  className?: any;
  style?: React.CSSProperties;
  marginRight?: number;
  loading?: boolean;
  height?: string;
}

const ButtonStyled = styled.button<IButton>(
  ({
    theme,
    background,
    color,
    fontSize,
    fontWeight,
    lineHeight,
    padding,
    width,
    bdr,
    border,
    margin,
    height,
  }) => ({
    position: "relative",
    color: color,
    background: background,
    fontSize: fontSize || theme.sizes.xs,
    fontWeight: fontWeight || 500,
    lineHeight: lineHeight,
    padding: padding,
    borderRadius: bdr || 6,
    border: border,
    width: width,
    height: height,
    margin: margin,
    textTransform: "capitalize",
    "&:hover": {
      cursor: "pointer",
    },
    "&:disabled": {
      background: theme.colors.border,
      cursor: "no-drop",
    },
    "&:focus": {
      border: "none",
    },
  })
);

const Button2: React.FC<IButton> = ({
  name,
  icon,
  marginRight,
  loading,
  ...rest
}) => {
  return (
    <ButtonStyled {...rest}>
      {icon && (
        <span style={{ marginRight: marginRight ? marginRight : 5 }}>
          {icon}
        </span>
      )}
      {loading && <Loading width={20} height={20} />}
      {name}
    </ButtonStyled>
  );
};

export default Button2;
